import { includesInLC, startsFromInLC } from '@datassential/platform-ui-lib';
import { IMacListItem } from '@models/MacListItem';
import { DocumentTypes } from '@pages/NewDocuments/DocumentView/DocumentView.helpers';

export function getMacSortingScore(item: IMacListItem, query: string): number {
    if (startsFromInLC(item.title, query)) return 4;
    if (includesInLC(item.title, query)) return 3;
    if (item.keywords.some((keyword) => startsFromInLC(keyword, query))) return 2;
    if (item.keywords.some((keyword) => includesInLC(keyword, query))) return 1;
    return 0;
}

export function filterAndRankMacs(items: IMacListItem[], query: string): IMacListItem[] {
    if (query.trim() === '') return [...items];

    return items
        .filter((item) => getMacSortingScore(item, query) > 0)
        .sort((a, b) => getMacSortingScore(b, query) - getMacSortingScore(a, query));
}

/** Payload for the shared SharePopup; BE resolves whether `id` is a new or legacy MAC id. */
export function getMacSharePayload(item: IMacListItem) {
    return {
        id: item.id,
        documentType: DocumentTypes.mac,
        shareLinkString: item.shareLink,
        publicationFamily: '',
        title: item.title,
        popupType: 'allDocuments',
    };
}
